// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4768":"61db6e8e","6045":"61db6e8e"}[chunkId] + ".chunk.css";
};